import { UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const marketingCampaignsSubNav: RouteListItem[] = [
  {
    path: '/marketing-campaigns/$id',
    icon: UserCircle,
    name: 'Marketing Campaign',
  },
];
